import { ReactNode } from 'react'
import { ITourContext } from './types'
import { defaultValue, TourContext } from './context'

interface Props {
  value: Partial<ITourContext>
  children: ReactNode
}

export const TourContextProvider = ({ value, children }: Props) => {
  const {
    getStepNumber = defaultValue.getStepNumber,
    stepNumbersOfLabel = defaultValue.stepNumbersOfLabel,
  } = value

  return (
    <TourContext.Provider
      value={{
        getStepNumber,
        stepNumbersOfLabel,
      }}
    >
      {children}
    </TourContext.Provider>
  )
}
